var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.043,
    height: 42.028,
    viewBox: "0 0 36.043 42.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDF_Preview",
    "data-name": "PDF Preview",
    transform: "translate(-74.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(77.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M157.12,0h17.439a2.47,2.47,0,0,1,2.463,2.463v37.1a2.47,2.47,0,0,1-2.463,2.463h-25.2a2.47,2.47,0,0,1-2.463-2.463V10.22",
    transform: "translate(-146.9)",
    fill: "#ffd2d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M157.12,0V7.757a2.47,2.47,0,0,1-2.463,2.463H146.9",
    transform: "translate(-146.9)",
    fill: "#e74c3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(74.818 25.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M76.238,559.922H78.91V556.4L76,560.028h0A.286.286,0,0,1,76.238,559.922Z",
    transform: "translate(-75.951 -556.4)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M883.372,559.922H880.7V556.4l2.91,3.628h0A.275.275,0,0,0,883.372,559.922Z",
    transform: "translate(-847.624 -556.4)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M108.041,650.027a.641.641,0,0,1-.554.386h-29.3a.634.634,0,0,1-.554-.386l-2.791-7.441a.268.268,0,0,1,.267-.386H110.57a.267.267,0,0,1,.267.386Z",
    transform: "translate(-74.818 -638.678)",
    fill: "#e74c3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(85.509 31.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M335.3,774.644a.609.609,0,0,1,.185-.476.77.77,0,0,1,.534-.168.718.718,0,0,1,.509.168.62.62,0,0,1,.176.476.612.612,0,0,1-.185.472.709.709,0,0,1-.5.168.783.783,0,0,1-.525-.168A.589.589,0,0,1,335.3,774.644Z",
    transform: "translate(-335.3 -770.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M392.963,685.36a1.628,1.628,0,0,1-.484,1.268,1.957,1.957,0,0,1-1.379.447h-.373V688.7H389.4v-4.9h1.7a2.074,2.074,0,0,1,1.4.406A1.434,1.434,0,0,1,392.963,685.36ZM390.73,686h.242a.667.667,0,0,0,.476-.168.6.6,0,0,0,.177-.464c0-.332-.185-.5-.55-.5h-.341V686Z",
    transform: "translate(-387.18 -683.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M499.366,686.148a2.534,2.534,0,0,1-.677,1.892,2.6,2.6,0,0,1-1.9.665H495.2v-4.9h1.7a2.556,2.556,0,0,1,1.822.6A2.271,2.271,0,0,1,499.366,686.148Zm-1.375.049a1.57,1.57,0,0,0-.267-1,.98.98,0,0,0-.809-.324h-.386v2.746h.3a1.071,1.071,0,0,0,.887-.349A1.714,1.714,0,0,0,497.991,686.2Z",
    transform: "translate(-488.637 -683.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M619.405,688.7H618.1v-4.9H621v1.063h-1.592v.936h1.469v1.063h-1.469Z",
    transform: "translate(-606.493 -683.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M408.9,300.751a4.88,4.88,0,0,1,6.477-2.048,4.754,4.754,0,0,1,2.1,2.048A4.88,4.88,0,0,1,411,302.8,4.732,4.732,0,0,1,408.9,300.751Zm4.29,1.705a1.706,1.706,0,1,0-1.752-1.705A1.727,1.727,0,0,0,413.19,302.456Zm0-.85a.855.855,0,1,1,.876-.855A.865.865,0,0,1,413.19,301.606Z",
    transform: "translate(-320.043 -283.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    d: "M6.4-.5A6.9,6.9,0,1,1-.5,6.4,6.9,6.9,0,0,1,6.4-.5Zm0,12.794A5.9,5.9,0,1,0,.5,6.4,5.9,5.9,0,0,0,6.4,12.294Z",
    transform: "translate(86.594 11.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_48",
    "data-name": "Line 48",
    d: "M3.478,3.982a.5.5,0,0,1-.354-.147L-.354.353a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0L3.831,3.129a.5.5,0,0,1-.354.853Z",
    transform: "translate(97.509 22.213)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfPreview);
export default __webpack_public_path__ + "static/media/PDF Preview.c5b0e880523a0d327e7dca5b4ddc3153.svg";
export { ForwardRef as ReactComponent };